import { RotasPublicRouterAppAtributos } from '@/@types/rotasRouterApp'

export const mapRotasPublicApp = (rotas: RotasPublicRouterAppAtributos[]) => {
  return rotas.map(({ Element, path }) => ({ path, element: <Element /> }))
}
